import type { KeyIconsType } from 'components/uiKit/Icon'

export const NODES_ICON_MAP: Record<string, KeyIconsType> = {
  absolute: 'absolute',
  grid: 'grid',
  flex: 'flexRow',
  'absolute-solo': 'absolute',
  'grid-solo': 'grid',
  'grid-repeatable': 'repeatable',
  'flex-row-solo': 'flexRow',
  'flex-column-solo': 'flexColumn',
  'flex-row-repeatable': 'repeatable',
  'flex-column-repeatable': 'repeatable',
}
